
       
        <div contentAnimate *ngIf="!isLoading" class="h-100">         
          <router-outlet></router-outlet>
        </div>
      